import { EntityManagerBaseEntity } from '../EntityManagerBaseEntity';
export class EntityUtils {
  private constructor() {}

  /**
   * an id based approach to compare if 2 entities have the same id
   */
  public static entitiesAreEqual(a: EntityManagerBaseEntity, b: EntityManagerBaseEntity): boolean {
    if (a.onlyLocal === b.onlyLocal) {
      return a.id === b.id;
    }
    if (a.onlyLocal) {
      // a is local and b is not local
      return b.originalIds.includes(a.id);
    }

    // b is local and a is not local
    return a.originalIds.includes(b.id);
  }

  /**
   * gets a key for the entity with which it can be tracked
   * using the id itself would not be stable, since the id changes when the entity gets synchronized and the tracking will get lost
   */
  public static getTrackingKey(entity: EntityManagerBaseEntity): string {
    if (!entity.onlyLocal) {
      const firstOriginalId = entity.originalIds[0];
      if (firstOriginalId) {
        return firstOriginalId;
      }
    }
    return entity.id;
  }
}